import { createAction } from "redux-actions";

import {
  getSeabirdFilename,
  handleSeabirdFileUpload,
  isSeabird
} from "util/seabird";
import {
  getRBRFilename,
  handleHexFileUpload,
  handleRBRFileUpload,
  handleRskFileUpload,
  isHex,
  isRBR,
  isRsk
} from "util/rbr";
import uploadPropsSelector from "./selectors";
import * as types from "./constants";
// eslint-disable-next-line import/no-cycle
import { filesToAnnotateInvalidate } from "../annotate/actions";
import { downloadCastsInvalidate } from "../download/actions";

/* eslint-disable max-len */
export const uploadFilesInvalidate = createAction(
  types.UPLOAD_FILES_INVALIDATE
);
export const uploadFileRequest = createAction(types.UPLOAD_FILE_REQUEST);
export const uploadFileSuccess = createAction(types.UPLOAD_FILE_SUCCESS);
export const uploadFileError = createAction(
  types.UPLOAD_FILE_ERROR,
  x => x,
  (x, m) => m
);
export const toggleHasStaticCasts = createAction(types.TOGGLE_HAS_STATIC_CASTS);
/* eslint-enable max-len */

// UPLOAD FILES ASYNC ACTION
export const uploadFiles = files => (dispatch, getState) => {
  const { workarea, organization, hasStaticCasts } = uploadPropsSelector(
    getState()
  );
  files.forEach(file => {
    // Alert for any file larger than 100MB
    const fileSizeMB = Math.round(file.size / 1024 / 1024);
    if (fileSizeMB > 100) {
      const userConfirmed = window.confirm(
        `You are trying to upload large file (${fileSizeMB}MB). Press ok if you want to proceed. ` +
          `Please be patient and email eims.support@hakai.org if something unexpected happens.`
      );

      if (!userConfirmed) {
        return; // Exit the function, don't process this file
      }
    }

    if (isSeabird(file)) {
      const fileNameExt = getSeabirdFilename(file);

      dispatch(uploadFileRequest({ workarea, organization, ...fileNameExt }));
      handleSeabirdFileUpload(file, workarea, organization)
        .then(json => {
          // eslint-disable-next-line no-console, no-unused-expressions
          window.console && console.log && console.log(json);
        })
        .then(() => dispatch(uploadFileSuccess(fileNameExt)))
        .then(() => dispatch(filesToAnnotateInvalidate()))
        .then(() => dispatch(downloadCastsInvalidate()))
        .catch(err => dispatch(uploadFileError(err, fileNameExt)));
    } else if (isRBR(file)) {
      const fileNameExt = getRBRFilename(file);

      dispatch(
        uploadFileRequest({
          workarea,
          organization,
          ...fileNameExt,
          static: hasStaticCasts
        })
      );
      handleRBRFileUpload(file, workarea, organization, hasStaticCasts)
        .then(json => {
          // eslint-disable-next-line no-console, no-unused-expressions
          window.console && console.log && console.log(json);
        })
        .then(() => dispatch(uploadFileSuccess(fileNameExt)))
        .then(() => dispatch(filesToAnnotateInvalidate()))
        .then(() => dispatch(downloadCastsInvalidate()))
        .catch(err => dispatch(uploadFileError(err, fileNameExt)));
    } else if (isRsk(file)) {
      const fileNameExt = getRBRFilename(file);

      dispatch(uploadFileRequest({ ...fileNameExt }));
      handleRskFileUpload(file, workarea, organization, hasStaticCasts)
        .then(json => {
          // eslint-disable-next-line no-console, no-unused-expressions
          window.console && console.log && console.log(json);
        })
        .then(() => dispatch(uploadFileSuccess(fileNameExt)))
        .catch(err => dispatch(uploadFileError(err, fileNameExt)));
    } else if (isHex(file)) {
      const fileNameExt = getRBRFilename(file);

      dispatch(uploadFileRequest({ workarea, organization, ...fileNameExt }));
      handleHexFileUpload(file, workarea, organization, hasStaticCasts)
        .then(json => {
          // eslint-disable-next-line no-console, no-unused-expressions
          window.console && console.log && console.log(json);
        })
        .then(() => dispatch(uploadFileSuccess(fileNameExt)))
        .catch(err => dispatch(uploadFileError(err, fileNameExt)));
    } else {
      dispatch(
        uploadFileRequest({ filename: file.name, workarea, organization })
      );
      const err = new Error(
        `Filename ${file.name} inconsistent with Seabird and RBR naming convention.

        Examples of standardized filenames include:
        SBE19plus_01907674_2020_01_01_0001.hex
        018032_20200101_1000.rsk
        209760_20231011_2223_0315080516.rsk
        209763_20250101_0000_Cervello.rsk
        018032_20200101_1000_eng.txt
        `
      );
      dispatch(uploadFileError(err, { filename: file.name }));
    }
  });
};
